<style scoped>
</style>

<template>
  <div class="my-list-menu">
    <MyListMenuItem
      v-for="(item, index) in data"
      v-bind:data="item"
      v-bind:key="index"
    />
  </div>
</template>

<script>
  import MyListMenuItem from './MyListMenuItem.vue'
  export default {
    name: 'MyListMenu',
    props: {
      data: {
        type: Array,
        default: []
      }
    },
    data () {
      return {
      }
    },
    components: {
      [MyListMenuItem.name]: MyListMenuItem
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/MyListMenu.vue